import request from '@/utils/axios'

export function getFaqs () {
  return request({
    url: '/api/faqs',
    methods: 'get'
  })
}
